import { useState } from "react"
import { useAllProducts } from "../../hooks/products"
import { useDisclosure, Button } from "@chakra-ui/react"
import ProductForm from "../../components/Products/ProductForm"
import ProductList from "../../components/Products/ProductList"
import Page from "../../components/Admin/Page"

const ProductsPage = () => {
  const {
    products,
    isLoading,
    addProduct,
    updateProduct,
    removeProduct,
  } = useAllProducts()

  const [selected, setSelected] = useState()
  const modalController = useDisclosure()

  return (
    <Page
      title="Inventario"
      isLoading={isLoading}
      toolbar={
        <Button
          colorScheme="teal"
          onClick={() => {
            setSelected()
            modalController.onOpen()
          }}
        >
          Nuovo Prodotto
        </Button>
      }
    >
      <ProductList
        items={products}
        selected={selected}
        setSelected={(item) => {
          setSelected(item)
          modalController.onOpen()
        }}
        toggleActive={(item) =>
          updateProduct(item.id, { active: !!!item.active })
        }
      />
      <ProductForm
        title={selected ? "Modifica Prodotto" : "Nuovo Prodotto"}
        item={selected}
        onSubmit={
          selected
            ? (values) => updateProduct(selected.id, values)
            : (values) => addProduct(values)
        }
        onRemove={removeProduct}
        modalController={modalController}
      />
    </Page>
  )
}

export default ProductsPage
